import { callKNBBridge, getBridgeType, BridgeType } from "./bridge/base";
import { Level, reportError } from "./owl";

// 获取指纹
const getFingerprint = (): Promise<string> => {
  const bridgeType = getBridgeType();
  if (bridgeType === BridgeType.KNB) {
    // KNB 桥获取指纹，通过 Promise 包装 callback
    return new Promise((resolve) => {
      callKNBBridge("getFingerprint", {
        success: (ret: { fingerprint: string }) => {
          resolve(ret?.fingerprint || "");
        },
        fail: (err: any) => {
          reportError({
            name: '[getFingerprint] getFingerprintError',
            msg: err,
            category: 'bridgeError',
            level: Level.WARN,
          })
          resolve('')
        },
      });
    });
  }
  if (H5guard && typeof H5guard.getfp === "function") {
    const fp = H5guard.getfp();
    return Promise.resolve(fp || "");
  }
  return Promise.resolve("");
};

export default getFingerprint;